import React from 'react';
import {pessoaTipoChoices, ProprietarioObject} from "models/Proprietario";
import {IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle} from "@ionic/react";
import {ProprietarioCardContent} from "../ProprietarioCard";
import {AppUser} from "models/app";

interface CardProprietarioProps {
  instance: ProprietarioObject
  onClick?: (instance: ProprietarioObject) => void;
  user: AppUser;
  numFazendas?: number;
}

const CardProprietario: React.FC<CardProprietarioProps> = (props) => {
  const {instance, onClick, user, numFazendas} = props;

  return (
    <IonCard
      button={!!onClick}
      onClick={onClick ? () => onClick(instance) : undefined}
    >
      <IonCardHeader>
        <IonCardSubtitle>
          Prorietário
          {instance.pessoa_tipo &&
            <span> ({pessoaTipoChoices.getLabel(instance.pessoa_tipo)})</span>
          }
        </IonCardSubtitle>
        <IonCardTitle>
          {instance.nome}
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <ProprietarioCardContent
          proprietario={instance}
          user={user}
          numFazendas={numFazendas}
        />
      </IonCardContent>
    </IonCard>
  );
}

export default CardProprietario;
